import { Pipe, PipeTransform } from '@angular/core';
import { HashMap } from '@ngneat/transloco';

@Pipe({
  name: 'translateStringArray',
  standalone: true,
})
export class TranslateStringArrayPipe implements PipeTransform {

  transform(values: string[], translocoFunction: (key: string, params?: HashMap) => any, prefix?: string): string[] {
    return values.map(value => prefix ? translocoFunction(`${ prefix }.${ value }`) : translocoFunction(value));
  }

}
